import React, { useState, useEffect } from "react";
import axios from "axios";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

const PcComponent = ({ userId, id }) => {
  const [pcTemplate, setPcTemplate] = useState(null);

  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.ViewUserProfil?.[key]?.[currentLang] ?? key;

  useEffect(() => {
    let isMounted = true;
    const fetchPC = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/get/trading-preferences/PC/` + id,
          { params: { id }, withCredentials: true }
        );
        if (!isMounted) return;
        setPcTemplate(data?.[0] ?? null);
      } catch (err) {
        console.error("PC fetch error:", err?.message || err);
        if (isMounted) setPcTemplate(null);
      }
    };
    fetchPC();
    return () => { isMounted = false; };
  }, [id]);

  // Helpers
  const isOn = (v) => v === 1 || v === true || v === "1";
  const splitComma = (val) =>
    String(val || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

  if (!pcTemplate) {
    return (
      <div className="pc-panel-body">
        <div className="pc-empty">{t("Loading...")}</div>
      </div>
    );
  }

  const hasAnyAttribute =
    isOn(pcTemplate.isOnlyAuto) ||
    isOn(pcTemplate.isOnlyRookie) ||
    isOn(pcTemplate.isOnlyRPA) ||
    isOn(pcTemplate.Number) ||
    isOn(pcTemplate.isOnlyTrueRookie);

  const players = splitComma(pcTemplate.PlayerNames);
  const sets = splitComma(pcTemplate.SetNames);
  const cardNames = splitComma(pcTemplate.CardNames);
  const variations = splitComma(pcTemplate.VariationNames);

  return (
    <div className="pc-panel-body">
      <div className="pc-grid">
        {pcTemplate.TypeOfCard && (
          <div className="pc-row">
            <b>{t("Type")}:</b>
            <p className="pc-value">{pcTemplate.TypeOfCard}</p>
          </div>
        )}

        {!!players.length && (
          <div className="pc-row">
            <b>{t("Player")}:</b>
            <div className="pc-names">
              {players.map((name, i) => (
                <p key={i}>{name}</p>
              ))}
            </div>
          </div>
        )}

        {!!sets.length && (
          <div className="pc-row">
            <b>Set:</b>
            <div className="pc-names">
              {sets.map((s, i) => (
                <p key={i}>{s}</p>
              ))}
            </div>
          </div>
        )}

        {!!cardNames.length && (
          <div className="pc-row">
            <b>{t("cardName")}:</b>
            <div className="pc-names">
              {cardNames.map((n, i) => (
                <p key={i}>{n}</p>
              ))}
            </div>
          </div>
        )}

        {!!variations.length && (
          <div className="pc-row">
            <b>{t("variation")}:</b>
            <div className="pc-names">
              {variations.map((v, i) => (
                <p key={i}>{v}</p>
              ))}
            </div>
          </div>
        )}

        {pcTemplate.OtherDetails && (
          <div className="pc-row">
            <b>{t("Other")}:</b>
            <p className="pc-value">{pcTemplate.OtherDetails}</p>
          </div>
        )}
      </div>

      {hasAnyAttribute && (
        <div className="pc-attributes">
          <p className="subhead">
            <b>{t("Attribute")}:</b>
          </p>
          <ul className="bullets">
            {isOn(pcTemplate.isOnlyTrueRookie) && (
              <li>
                {t("OnlyTrueRookie")} – YG, FWA, FWAP, Ice/99, SGPU #/jersey, Premier RPA /299, The Cup /249
              </li>
            )}
            {isOn(pcTemplate.isOnlyRookie) && <li>{t("OnlyRookie")}</li>}
            {isOn(pcTemplate.isOnlyRPA) && <li>{t("OnlyRPA")}</li>}
            {isOn(pcTemplate.isOnlyAuto) && <li>{t("OnlyAuto")}</li>}
            {isOn(pcTemplate.Number) && <li>{t("OnlyNumberedCard")}</li>}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PcComponent;
